// useCurrentLocation.js
import { useEffect, useState } from 'react';

export default function useCurrentLocation() {
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [error, setError] = useState(null);

  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (err) => setError(err)
      );
    } else {
      setError(new Error('Geolocation not supported'));
    }
  }, []);

  return { location, error };
}
